import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Updates from "@/pages/Updates";
import GovtHealthList from "@/pages/GovtHealthList";
import GovtHealthHub from "@/pages/GovtHealthHub";
import Communities from "@/pages/Communities";
import CommunityDetail from "@/pages/CommunityDetail";
import Admin from "@/pages/Admin";
import VerifyProfessional from "@/pages/VerifyProfessional";
import Saved from "@/pages/Saved";
import Events from "@/pages/Events";
import Opportunities from "@/pages/Opportunities";
import { Achievements, Messages, SettingsPage, More } from "@/pages/Misc";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import VerifyEmail from "@/pages/auth/VerifyEmail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Updates />} />
              <Route path="/govt-health" element={<GovtHealthList />} />
              <Route path="/govt-health/:slug" element={<GovtHealthHub />} />
              <Route path="/communities" element={<Communities />} />
              <Route path="/communities/:id" element={<CommunityDetail />} />
              <Route path="/verify-professional" element={<VerifyProfessional />} />
              <Route path="/events" element={<Events />} />
              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/achievements" element={<Achievements />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/saved" element={<Saved />} />
              <Route path="/more" element={<More />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
